<script>
  export let show = true;
  import { slide } from 'svelte/transition';
</script>

<style>
  .intro {
    border-bottom: 1px dashed #9D9D9D;
    margin-bottom: 3rem;
    padding-bottom: 2rem;
  }
</style>

{#if show}
<div class="intro" transition:slide>
  <p>October 2020</p>
  <p>The Yemen Matrix is an interactive tool covering relationships between the core actors involved in the country’s various conflicts. Users can search by actor or relationship, and icons locate each relationship along the spectrum from ally to adversary, accompanied by a brief explanation and clickable related events. Each actor page includes a concise profile and map; each group also includes a select list of members.</p>
  <p>To view the full project, <a target="_blank" href="https://www.washingtoninstitute.org/media/4222?disposition=inline">download the PDF</a>.</p>

  <div class="hide-for-desktop">
    <p><em>Relationship matrix is best viewed on desktop.</em></p>
  </div>
</div>
{/if}
